import { getErrorMessage } from '@/utilities';
import { ApiError } from '@/types';
import { ErrorCode } from '@/configs/errorCode';
import axios, { AxiosError, HttpStatusCode, isAxiosError } from 'axios';
import APP_CONFIG from '../configs/appConfig';
import { getSession } from 'next-auth/react';

const httpClient = axios.create({
	baseURL: process.env.NEXT_PUBLIC_API_URL,
	headers: {
		Accept: 'application/json',
		'Content-type': 'application/json; charset=UTF-8',
		'Accept-Language': APP_CONFIG.APP_LANGUAGE,
	},
});

httpClient.interceptors.request.use(async (request) => {
	if (request.data instanceof FormData) request.headers.setContentType('');

	if (typeof window !== 'undefined') {
		const session = await getSession();
		if (session?.accessToken) {
			request.headers.Authorization = `Bearer ${session.accessToken}`;
		}
	}

	return request;
});

httpClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (isAxiosError<ApiError>(error)) {
			if (error.code === AxiosError.ECONNABORTED) throw error;

			const stack = Array.isArray(error.response!.data.message)
				? error.response!.data.message
				: [error.response!.data.message];

			throw {
				status: error.response!.data.status,
				stack,
				message: getErrorMessage(stack),
			};
		}

		throw {
			code: HttpStatusCode.InternalServerError,
			stack: [ErrorCode.GENERIC],
			message: getErrorMessage(ErrorCode.GENERIC),
		};
	}
);

export default httpClient;
